import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-horse-racing.svg";
import * as styles from "./Icon.module.scss";

type HorseRacingProps = React.SVGProps<SVGSVGElement>;

export const HorseRacing = ({ className, ...props }: HorseRacingProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
